// @flow

import connect from '@active/awe-ui-core/lib/hoc/connect';
import { getLocale } from 'modules/app/selector';
import EventHeader from 'components/EventHeader/EventHeader';
import { getWhiteLabelHeader } from 'modules/whiteLabel/selector';

import { getEvent } from '../duck/selector';

const mapState = state => ({
  raceEvent: getEvent(state),
  locale: getLocale(state),
  whiteLabelHeader: getWhiteLabelHeader(state),
});

export default connect(mapState)(EventHeader);
